import { render, staticRenderFns } from "./textComponent.vue?vue&type=template&id=3e669b35&scoped=true&"
import script from "./textComponent.vue?vue&type=script&lang=js&"
export * from "./textComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e669b35",
  null
  
)

export default component.exports